module.exports = __webpack_public_path__ + "static/media/bi_symbol_image_white.d43524e5.png";